module.exports = __webpack_public_path__ + "static/media/d9kz.31348a82.pdf";